// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"96":"29d9b491","383":"6ad1ecd2","701":"a2361264","791":"f84e3eda","941":"2693c308"}[chunkId] + ".chunk.js";
};